import React from 'react'
import { Alert } from '@material-ui/lab'
import { withStyles } from '@material-ui/styles'

import styles from './styles'

const EmptyStateMessage = ({ classes, title }) => {
  return (
    <Alert severity="error" className={classes.alert}>
      {title}
    </Alert>
  )
}

export default withStyles(styles)(EmptyStateMessage)
